/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RttrFinalistEntry } from './RttrFinalistEntry';
import {
    RttrFinalistEntryFromJSON,
    RttrFinalistEntryFromJSONTyped,
    RttrFinalistEntryToJSON,
    RttrFinalistEntryToJSONTyped,
} from './RttrFinalistEntry';

/**
 * 
 * @export
 * @interface RttrFinalistsResponse
 */
export interface RttrFinalistsResponse {
    /**
     * 
     * @type {string}
     * @memberof RttrFinalistsResponse
     */
    challengeId: string;
    /**
     * 
     * @type {Array<RttrFinalistEntry>}
     * @memberof RttrFinalistsResponse
     */
    finalists: Array<RttrFinalistEntry>;
    /**
     * The round index the `value` scores are drawn from (active round, or latest ended round between/after rounds).
     * @type {number}
     * @memberof RttrFinalistsResponse
     */
    currentRound: number;
}

/**
 * Check if a given object implements the RttrFinalistsResponse interface.
 */
export function instanceOfRttrFinalistsResponse(value: object): value is RttrFinalistsResponse {
    if (!('challengeId' in value) || value['challengeId'] === undefined) return false;
    if (!('finalists' in value) || value['finalists'] === undefined) return false;
    if (!('currentRound' in value) || value['currentRound'] === undefined) return false;
    return true;
}

export function RttrFinalistsResponseFromJSON(json: any): RttrFinalistsResponse {
    return RttrFinalistsResponseFromJSONTyped(json, false);
}

export function RttrFinalistsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrFinalistsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challengeId': json['challengeId'],
        'finalists': ((json['finalists'] as Array<any>).map(RttrFinalistEntryFromJSON)),
        'currentRound': json['currentRound'],
    };
}

export function RttrFinalistsResponseToJSON(json: any): RttrFinalistsResponse {
    return RttrFinalistsResponseToJSONTyped(json, false);
}

export function RttrFinalistsResponseToJSONTyped(value?: RttrFinalistsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challengeId': value['challengeId'],
        'finalists': ((value['finalists'] as Array<any>).map(RttrFinalistEntryToJSON)),
        'currentRound': value['currentRound'],
    };
}

